<template>
  <div>
    <MainMenu />
    <v-main class="py-0">
      <v-img 
        min-height="250" 
        max-height="250" 
        src="@/assets/FinancingImages/financiamento.jpg"
      ></v-img>
      <v-container>
        <v-layout column>
          <v-col cols="7" >
            <h1 class="py-3">Simule o seu financiamento</h1>
          </v-col>
          <v-layout row wrap justify-center>
            <a target="_blank" rel="noopener noreferrer" href="http://www8.caixa.gov.br/siopiinternet-web/simulaOperacaoInternet.do?method=inicializarCasoUso">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/caixa.png"
                
              ></v-img>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://banco.bradesco/html/classic/produtos-servicos/emprestimo-e-financiamento/encontre-seu-credito/simuladores-imoveis.shtm">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/bradesco.png"
              ></v-img>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.itau.com.br/emprestimos-financiamentos/credito-imobiliario/simulador/">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/itau.png"
              ></v-img>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www42.bb.com.br/portalbb/imobiliario/creditoimobiliario/simular,802,2250,2250.bbx">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/banco_brasil.png"
              ></v-img>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://creditoimobiliario.santander.com.br/credito_imobiliario/Simulador/">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/santander.png"
              ></v-img>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="http://www.banrisul.com.br/bob/link/bobw02hn_conteudo_lista2.aspx?secao_id=1069">
              <v-img 
                min-height="200" 
                max-height="200"
                min-width="200"
                max-width="200"
                src="@/assets/FinancingImages/banrisul.png"
              ></v-img>
            </a>
          </v-layout>
        </v-layout>
      </v-container>
    </v-main>
    <v-spacer class="pt-10"></v-spacer>
    <BottomBar />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import MainMenu from '@/components/Global/MainMenu.vue'
import BottomBar from '@/components/Global/BottomBar.vue'

export default {
  name: 'FinancingScreen',

  components: {
    MainMenu,
    BottomBar,
  },

  data: () => ({

  }),

  mounted() {
    this.cleanBuyMenuId()
    this.cleanRentMenuId()
  },

  computed: {

  },

  watch: {

  },

  methods: {
    ...mapActions({
      cleanBuyMenuId: 'Immobile/cleanBuyMenuId',
      cleanRentMenuId: 'Immobile/cleanRentMenuId',
    }),

    ...mapGetters({

    }),
  },
};
</script>